import {useUserToken} from '@aboutyou/user';
import React, {useEffect} from 'react';
import {useIsCustomerSessionValid} from '../../features/Checkout/useIsCustomerSessionValid/useIsCustomerSessionValid';
import {useSubscribeToWhatsappNewsletter} from './hooks/useSubscribeToWhatsappNewsletter';

export const SubscribeToWhatsappNewsletter: React.FC<{
  whatsappUUIDToken: string;
  countryCode: string;
}> = ({whatsappUUIDToken, countryCode}) => {
  const customerSessionValidity = useIsCustomerSessionValid();
  const authToken = useUserToken();
  const subscribeToWhatsappNewsletterCallback =
    useSubscribeToWhatsappNewsletter();

  useEffect(() => {
    if (customerSessionValidity.canAccessCheckout) {
      subscribeToWhatsappNewsletterCallback(
        authToken!,
        whatsappUUIDToken,
        countryCode,
      );
    }
  }, [authToken, countryCode, customerSessionValidity, whatsappUUIDToken]);

  return null;
};
